<template>
  <div
    v-if="moduleData && moduleData.id"
    class="module-options"
  >
    <MediaOptions
      :canvas-name="canvasName"
      :is-audio-asset="group === 'audio'"
      :is-image-asset="group === 'image'"
      :is-video-asset="group === 'video'"
      :module-data="moduleData"
      @update-module="updateMediaOptions"
    />

    <div
      class="module-options__inner module-options__inner--top-padded"
      v-if="moduleData.options.layout !== 'image'"
    >
      <div class="module-options__item module-options__item--text">
        <legend class="module-options__legend">
          {{ $t('Title') }}
        </legend>
        <NebulaInput
          class="module-options__text-input"
          :text="decodedTitle"
          type="text"
          @input="changeTitle"
        />
      </div>
      <div class="module-options__item module-options__item--text">
        <legend class="module-options__legend">
          {{ $t('Description') }}
        </legend>
        <NebulaInput
          class="module-options__text-input"
          :text="decodedDescription"
          type="text"
          @input="changeDescription"
        />
      </div>
    </div>
    <ShapeBorderOptions
      :canvas-name="canvasName"
      :module-data="moduleData"
    />
  </div>
</template>

<script>
import { NebulaInput } from '@discoveryedu/nebula-components';
import { cloneDeep, get, set } from 'lodash-es';
import { mapActions, mapState } from 'pinia';
import MediaOptions from '@/components/media/MediaOptions.vue';
import ShapeBorderOptions from '@/components/modules/ShapeBorderOptions.vue';
import * as types from '@/lib/constants/store';
import { getGroupFromFileType } from '@/lib/constants';
import { decodeHTML } from '@/lib/utils';
import {
  useAssetStore,
  useEditorStore,
  useUploadStore,
} from '@/stores';

export default {
  name: 'UploadModuleOptions',
  components: {
    MediaOptions,
    NebulaInput,
    ShapeBorderOptions,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useAssetStore, [
      'assets',
    ]),
    ...mapState(useUploadStore, [
      'uploads',
    ]),
    asset() {
      const assetId = get(this.moduleData, 'options.asset_id');
      return assetId && this.assets[assetId];
    },
    decodedDescription() {
      // Descriptions are escaped on the BE and must be unescaped (e.g. &amp; => &)
      if (!this.moduleData.options) return '';
      return decodeHTML(this.moduleData.options.description);
    },
    decodedTitle() {
      // Titles are escaped on the BE and must be unescaped (e.g. &amp; => &)
      if (!this.moduleData.options) return '';
      return decodeHTML(this.moduleData.options.title);
    },
    group() {
      if (this.asset) return this.asset.group;

      const uploadId = get(this.moduleData, 'options.upload_id');
      const contentType = get(this, `uploads[${uploadId}].content_type`);
      return getGroupFromFileType(contentType);
    },
  },
  methods: {
    ...mapActions(useUploadStore, [
      types.CACHE_UPLOAD,
    ]),
    ...mapActions(useEditorStore, [
      types.UPDATE_MODULE,
    ]),
    changeTitle(title) {
      const data = cloneDeep(this.moduleData);
      set(data, 'options.title', title);
      this[types.UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
    changeDescription(description) {
      const data = cloneDeep(this.moduleData);
      set(data, 'options.description', description);
      this[types.UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
    updateMediaOptions(data) {
      this[types.UPDATE_MODULE]({ canvasName: this.canvasName, payload: data });
    },
  },
};
</script>
